<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>I Hope You Dance: A Year of Weddings Novella</title><link href="styles/default.css" rel="stylesheet" type="text/css"/>
<p class="txc1" id="pz3-1">To the One who causes His children to take up their tambourines and go forth to the dances of the merrymakers.</p>
<p class="txc">—J<span class="small">EREMIAH</span> 31:4</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7a3b6d34